import React from "react";
import { EmailDetailBody } from "tsi-common-react/src/apps/customer-account/EmailDetailBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.EmailDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <EmailDetailBody {...props} />
    </PageSkeleton>
);
